import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from "@/components/Dashboard";
import Materials from "@/views/Material/Materials";
import RequisitionOrderItems from "@/views/RequisitionOrder/RequisitionOrderItems";
import Trips from "@/views/Trip/Trip";
import RequisitionOrderHistory from "@/views/RequisitionOrder/RequisitionOrderHistory";
import Preferences from "@/views/Preferences/Preferences";
import Notifications from "@/views/Notifications/Notifications";
import Users from "@/views/Users/Users";
import Roles from "@/views/Roles/Roles";
import FavoriteLists from "@/views/FavoriteLists/FavoriteLists";
import AccessDenied from "@/views/AccessControl/AccessDenied";
import Login from "@/views/AccessControl/Login";
import Home from "@/views/Home/Home";

Vue.use(Router)

export default new Router ({
    routes : [
    {
        path: '/',
        component: Home,
        name: 'home',
        meta: {
            auth: true,
            title: 'VRS Home'
        }
    },
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            auth: false,
            title: 'Login'
        }
    },
    {
        path: '/location/:locationId/locationdepartment/:locationDepartmentId/requisitionorder/:requisitionOrderId/materials',
        component: Materials,
        name: 'materials',
        meta: {
            auth: true,
            title: 'Materials'
        }
    },
    {
        path: '/location/:locationId/locationdepartment/:locationDepartmentId/requisitionorder/:id',
        component: RequisitionOrderItems,
        name: 'requisitionorder',
        meta: {
            auth: true,
            title: 'Requisition Order'
        }
    },
    {
        path: '/favoritelists',
        component: FavoriteLists,
        name: 'favoritelists',
        meta: {
            auth: true,
            title: 'Favorite Lists'
        }
    },
    {
        path: '/location/:locationId/locationdepartment/:locationDepartmentId/trips/',
        component: Trips,
        name: 'trips',
        meta: {
            auth: true,
            title: 'Trip Schedules',
            accessRequired: ["SCHEDULE", "COMPLETERO"]
        }

    },
    {
        path: '/location/:locationId/orderhistory/',
        component: RequisitionOrderHistory,
        name: 'orderhistory',
        meta: {
            auth: true,
            title: 'Requisition Orders History'
        }

    },
    {
        path: '/preferences/',
        component: Preferences,
        name: 'preferences',
        meta: {
            auth: true,
            title: 'User Preferences'
        }

    },
    {
        path: '/notifications',
        component: Notifications,
        name: 'notifications',
        meta: {
            auth: true,
            title: 'Notifications'
        }
    },
    {
        path: '/users',
        component: Users,
        name: 'users',
        meta: {
            auth: true,
            title: 'Users Administration',
            accessRequired: ["USERADMIN"]
        }
    },
    {
        path: '/roles',
        component: Roles,
        name: 'roles',
        meta: {
            auth: true,
            title: 'Roles Administration',
            accessRequired: ["ROLEADMIN"]
        }
    },
    {
        path: '/accessdenied',
        component: AccessDenied,
        name: 'accessdenied',
        meta: {
            auth: false,
            title: 'Access Denied'
        }
    },
]}
);